// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"281":"2e55464e","290":"2962e080","383":"df64a2ca","609":"3e4107be","612":"2e7ef6a8","691":"73c01b1d","722":"00c66a01"}[chunkId] + ".chunk.js";
};